import RoutesConstant from "./routes";
import { ReactComponent as EventsIcon } from "../icons/events.svg";
import { ReactComponent as StudentAttendance } from "../icons/student-attendance.svg";

const menuItems = [
  {
    key: "dashboard",
    Icon: "dashboard-icon",
    label: "Dashboard",
    path: RoutesConstant.DASHBOARD,
  },
  {
    key: "curriculum",
    Icon: "book-open",
    label: "Curriculum",
    children: [
      {
        key: "school-information",
        Icon: "book-closed",
        label: "School Information",
        path: RoutesConstant.SCHOOL_INFORMATION,
      },
      // {
      //   key: "subjects",
      //   Icon: "book-closed",
      //   label: "Subjects",
      //   path: RoutesConstant.SUBJECTS,
      // },
      // {
      //   key: "attendance-register",
      //   Icon: "bar-chart",
      //   label: "Attendance Register",
      //   path: RoutesConstant.ATTENDANCE_REGISTER,
      // },
      // {
      //   key: "setup-class-routine",
      //   Icon: "clipboard",
      //   label: "Setup Class & Routine",
      //   path: RoutesConstant.SETUP_CLASS_ROUTINE,
      // },
      {
        key: "schedule-examination",
        Icon: "clipboard",
        label: "Schedule Examination",
        path: RoutesConstant.SCHEDULE_EXAMINATION,
      },
      {
        key: "report-card-management",
        Icon: "report-card-icon",
        label: "Report Card Management",
        path: RoutesConstant.REPORT_CARD_MANAGEMENT,
      },
      {
        key: "student-promotion",
        Icon: "student-promotion-icon",
        label: "Student Promotion",
        path: RoutesConstant.STUDENT_PROMOTION,
      },
    ],
  },
  {
    key: "institutions",
    Icon: "institution-icon",
    label: "Institutions/Schools",
    path: RoutesConstant.INSTITUTIONS,
    aliasPaths: [
      RoutesConstant.INSTITUTION_DETAILS,
      RoutesConstant.INSTITUTION_FORM,
    ],
  },
  {
    key: "institution_owners",
    Icon: "institution-owners-icon",
    label: "School Ownership/Status",
    path: RoutesConstant.INSTITUTION_OWNERS,
  },
  {
    key: "product_demo",
    Icon: "demo-icon",
    label: "Product Demo",
    path: RoutesConstant.PRODUCT_DEMO,
  },
  {
    key: "contact-queries",
    Icon: "contact-query",
    label: "Contact Queries",
    path: RoutesConstant.CONTACT_QUERIES,
  },
  {
    key: "publish_parent_form",
    Icon: "parent-form",
    label: "Parent Form",
    path: RoutesConstant.PUBLISH_PARENT_FORM,
  },
  {
    key: "school_statistics",
    Icon: "profile-icon",
    label: "School Statistics ",
    path: RoutesConstant.SCHOOL_STATISTICS,
  },
  {
    key: "students",
    Icon: "graduation-hat-icon",
    label: "Students",
    path: RoutesConstant.STUDENTS,
    aliasPaths: [
      RoutesConstant.STUDENT_LIST,
      RoutesConstant.STUDENT_DETAILS,
      RoutesConstant.STUDENT_FORM,
    ],
  },
  {
    key: "teachers",
    Icon: "people-icon",
    label: "Teachers",
    path: RoutesConstant.TEACHERS,
    aliasPaths: [
      RoutesConstant.TEACHER_LIST,
      RoutesConstant.TEACHER_DETAILS,
      RoutesConstant.TEACHER_FORM,
    ],
  },
  {
    key: "attendance",
    Icon: "bar-chart",
    label: "Attendance",
    children: [
      {
        key: "teacher-attendance",
        Icon: "teacher-attendance",
        label: "Teacher Attendance",
        path: RoutesConstant.TEACHER_ATTENDANCE,
      },

      {
        key: "student-attendance",
        Icon: StudentAttendance,
        label: "Student Attendance",
        path: RoutesConstant.STUDENT_ATTENDANCE,
      },
    ],
  },
  {
    key: "staff",
    Icon: "users-icon",
    label: "Staff",
    path: RoutesConstant.STAFF,
  },
  {
    key: "user_role_management",
    Icon: "users-icon",
    label: "User Role Management",
    path: RoutesConstant.USER_ROLE_MANAGEMENT,
  },
  {
    key: "communications",
    Icon: "communication",
    label: "Communication",
    children: [
      {
        key: "announcement",
        Icon: "announcement",
        label: "Announcement",
        path: RoutesConstant.ANNOUNCEMENT,
      },
      {
        key: "newsletter",
        Icon: "newsletter",
        label: "Newsletter",
        path: RoutesConstant.NEWSLETTER,
        aliasPaths: [RoutesConstant.NEWSLETTER_FORM],
      },
      {
        key: "communication",
        Icon: "chat-icon",
        label: "Direct Chat",
        path: RoutesConstant.CHAT,
      },
      {
        key: "customer-support",
        Icon: "support",
        label: "Customer Support",
        path: RoutesConstant.CUSTOMER_SUPPORT,
        aliasPaths: [
          RoutesConstant.SUPPORT_CHAT,
        ],
      },
      {
        key: "support",
        Icon: "support",
        label: "Support",
        path: RoutesConstant.SUPPORT,
      },
    ],
  },
  {
    key: "accounting",
    Icon: "accounting",
    label: "Accounting",
  },
  {
    key: "holiday_leave",
    Icon: "calendar-check-icon",
    label: "Holiday & Leave",
    path: RoutesConstant.HOLIDAY_LEAVE,
  },
  {
    key: "event",
    Icon: EventsIcon,
    label: "Events",
    path: RoutesConstant.EVENT,
  },
  {
    key: "settings",
    Icon: "settings-icon",
    label: "Settings",
    path: RoutesConstant.SETTINGS,
  },
  {
    key: "logout",
    Icon: "logout-icon",
    label: "Logout",
  },
];

export default menuItems;
